import React from "react"
import { renderToStaticMarkup } from "react-dom/server"
import { BackgroundPositionProps, BackgroundSizeProps, backgroundSize, backgroundPosition } from "styled-system"
import styled from "styled-components"

import { Box, BoxProps, FlexContainerProps } from "components/box"

type SvgBoxProps = BackgroundPositionProps & BackgroundSizeProps & { svgBgUriString: string[] }

const SvgBox = styled(Box)<SvgBoxProps>`
  height: 100%;
  width: 100%;
  background-repeat: no-repeat;
  background-size: 100% 100%;
  background-position: center center;
  background-image: ${props => props.svgBgUriString[0]};

  @media screen and (min-width: ${props => props.theme.breakpoints.sm}px) {
    background-image: ${props => props.svgBgUriString[1]};
  }

  @media screen and (min-width: ${props => props.theme.breakpoints.md}px) {
    background-image: ${props => props.svgBgUriString[2]};
  }

  @media screen and (min-width: ${props => props.theme.breakpoints.lg}px) {
    background-image: ${props => props.svgBgUriString[3]};
  }

  ${backgroundPosition}
  ${backgroundSize}
`

type SvgBackgroundProps = {
  svg: React.FC | (React.FC | "none")[]
} & BoxProps &
  FlexContainerProps &
  BackgroundPositionProps &
  BackgroundSizeProps

export const SvgBackgroundBox: React.FC<SvgBackgroundProps> = ({ children, svg, ...gridProps }) => {
  const svgNodes = Array.isArray(svg) ? svg : [svg]
  const svgBgUriString = svgNodes.map(svgNode =>
    typeof svgNode === "string"
      ? "none"
      : `url("data:image/svg+xml,${encodeURIComponent(renderToStaticMarkup(svgNode({})!))}")`
  )

  return (
    <SvgBox svgBgUriString={svgBgUriString} {...gridProps}>
      {children}
    </SvgBox>
  )
}
